import { jsxs, jsx } from "react/jsx-runtime";
import { Paragraph, Anchor, Box } from "@zillow/constellation-10";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { setServerUrl, createMax } from "../../utils/mortgagehelpers/mortgage-helpers.esm.js";
import { commaSeparateNumber } from "../../utils/zhl-calculator.esm.js";
import LegalPopover from "../CalculatorForm/LegalPopover.esm.js";
import SelectField from "../Fields/SelectField.esm.js";
import TextField from "../Fields/TextField.esm.js";
import { useLastValidClosingCostCalculator, FieldConfig, fetchRate, fetchPropertyTaxRate, roundToNearestInteger } from "./ClosingCostCalculator.utils.esm.js";
import DownPaymentField from "./DownPaymentField.esm.js";
import InterestRate from "./InterestRateField.esm.js";
const ClosingCostFields = () => {
  const lastValidClosingCostCalculator = useLastValidClosingCostCalculator();
  const {
    homePrice,
    downPayment
  } = lastValidClosingCostCalculator.fields;
  const form = useFormContext();
  const fieldInterestRate = form.register(FieldConfig.interestRate.name, FieldConfig.interestRate.config);
  const fieldPropertyTaxes = form.register(FieldConfig.propertyTaxes.name, FieldConfig.propertyTaxes.config);
  const fieldPropertyTaxRate = form.register(FieldConfig.propertyTaxRate.name, FieldConfig.propertyTaxRate.config);
  useEffect(() => {
    setServerUrl();
    createMax();
    if (fieldInterestRate) {
      const getLatestRate = async () => {
        const rate = await fetchRate(homePrice, downPayment);
        form.setValue(fieldInterestRate.name, rate);
      };
      getLatestRate();
    }
    if (fieldPropertyTaxes) {
      const getPropertyTaxes = async () => {
        const taxRate = await fetchPropertyTaxRate();
        const taxAmount = taxRate == 0 ? 315 : taxRate / 100 * homePrice / 4;
        taxRate != 0 && form.setValue(fieldPropertyTaxRate.name, taxRate);
        form.setValue(fieldPropertyTaxes.name, roundToNearestInteger(taxAmount));
      };
      getPropertyTaxes();
    }
  }, []);
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx(TextField, { label: "Home price", name: FieldConfig.homePrice.name, config: FieldConfig.homePrice.config, autoComplete: "off", format: commaSeparateNumber, required: true }),
    /* @__PURE__ */ jsx(DownPaymentField, {}),
    /* @__PURE__ */ jsx(InterestRate, { homePrice, downPayment }),
    /* @__PURE__ */ jsx(SelectField, { options: FieldConfig.purchasingAnyDiscountPoints.options, label: "Are you purchasing discount points?", name: FieldConfig.purchasingAnyDiscountPoints.name, config: FieldConfig.purchasingAnyDiscountPoints.config, tooltip: {
      title: "Are you purchasing discount points?",
      body: /* @__PURE__ */ jsxs(Paragraph, { children: [
        "You can pay",
        " ",
        /* @__PURE__ */ jsx(Anchor, { href: "https://www.zillow.com/learn/mortgage-points/", target: "_blank", children: "discount points" }),
        " ",
        "to reduce the loan's interest rate. Each point represents 1% of the loan amount and typically lowers the interest rate by 0.25%. For example, on a $300,000 loan at 6.25%, one discount point would cost you $3,000 and lower your interest rate to a flat 6%."
      ] })
    } }),
    /* @__PURE__ */ jsx(Box, { css: {
      display: "flex",
      justifyContent: "flex-start",
      marginTop: "0px"
    }, children: /* @__PURE__ */ jsx(LegalPopover, { style: {
      marginTop: "0px"
    }, triggerText: "Calculator disclaimer", text: "The closing cost calculator is intended to be used for educational purposes only. Actual costs may vary based on specific lender fees, local assessments, and other factors such as loan type and geography. This calculator does not include all potential closing costs, such as mortgage insurance premiums (if applicable), transfer taxes, or other fees associated with specific loan programs or property locations. It is recommended to consult with a licensed  lender in your area for a more precise estimate of your closing costs. Zillow Group Marketplace, Inc. does not make loans and this is not a commitment to lend." }) })
  ] });
};
export {
  ClosingCostFields as default
};
